module.exports = __webpack_public_path__ + "static/img/icon-rank@2x.a98daccc.png";